import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.value != this.props.value) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        if (nextProps.disabled != this.props.disabled) {
            return true;
        }

        return false;
    }

    render({ type, isHeight }) {
        const placeholder = this.props.placeholder;
        const multiline_error = this.props.error && this.props.error.length > 60;
        let class_name = this.props.error ? 'has-error ' : '';

        if (this.props.label) {
            class_name = `${class_name}has-label `;
        }

        if (multiline_error) {
            class_name = `${class_name}has-error-multiline `;
        }

        if (isHeight) {
            class_name = `${class_name}is-height-${isHeight} `;
        }

        if (type !== 'date') {
            delete(this.props.placeholder);
        }

        return (
            <input-group className={class_name}>
                {this.renderPlaceholder(type, placeholder)}
                {this.renderLabelAndInfo()}
                <input
                    {...this.props}
                    className={this.props.error ? 'error' : ''}
                    autoComplete={this.props.autocomplete || 'new-password'}
                />
                {this.renderError(multiline_error)}
            </input-group>
        );
    }

    renderLabelAndInfo = () => {
        if (this.props.label || this.props.info) {
            return (
                <row>
                    {this.renderLabel()}
                    {this.renderInfo()}
                </row>
            );
        }

        return null;
    }

    renderLabel = () => {
        if (this.props.label) {
            return (
                <column className={this.props.info ? 'is-6' : 'is-12'}>
                    <label>{this.props.label}</label>
                </column>
            );
        }

        return null;
    }

    renderInfo = () => {
        if (this.props.info) {
            return (
                <column className={`has-text-right has-padding-10-right ${this.props.label ? 'is-6' : 'is-12'}`}>
                    <a tooltip={this.props.info}>More Info</a>
                </column>
            );
        }

        return null;
    }

    renderPlaceholder = (type, placeholder) => {
        if (!_.contains(['date', 'time', 'month'], type) && placeholder && !this.props.value) {
            return (
                <div className='input-group-placeholder'>{placeholder}</div>
            );
        }

        return null;
    }

    renderError = (multiline) => {
        if (this.props.error) {
            return (
                <p className={`${multiline ? 'is-error-multiline' : 'is-error'}`}>
                    {this.props.error}
                </p>
            );
        }

        return null;
    }
}

export default connect()(Component);
